import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type TrimLevelNameClasses =
  | 'primaryName'
  | 'secondaryName'
  | 'primaryNameTitleSection'
  | 'primaryNameSummarySection'
  | 'secondaryNameTitleSection'
  | 'secondaryNameSummarySection'
  | 'divider'
  | 'modelNameText'
  | 'variantNameText'
  | 'trimLevelsPageTitle';

const trimLevelNameStyles = makeStyles<ISpcTheme, TrimLevelNameClasses>(
  ({ typography, palette, breakpoints }) => ({
    primaryName: {
      fontSize: typography.fontLG,
      fontWeight: typography.fontWeightBold,
      lineHeight: '22px',
      marginBottom: '5px',
      width: '100%',
    },
    secondaryName: {
      color: palette.text.primary,
      display: 'inline-block',
      fontSize: typography.fontSM,
      paddingLeft: 5,
      lineHeight: '16px',
      [breakpoints.down(breakpoints.values.sm)]: {
        fontSize: typography.fontXXS,
        lineHeight: '12px',
      },
    },
    primaryNameTitleSection: {
      fontSize: typography.fontXL,
      fontWeight: 400,
      lineHeight: '24px',
      [breakpoints.down(breakpoints.values.sm)]: {
        textAlign: 'center',
      },
    },
    secondaryNameTitleSection: {
      fontSize: typography.fontMD,
      lineHeight: '18px',
      letterSpacing: '-0.2px',
      [breakpoints.down(breakpoints.values.sm)]: {
        fontSize: typography.fontXXS,
        lineHeight: '10px',
      },
    },
    primaryNameSummarySection: {
      fontSize: typography.fontMD,
      fontWeight: 400,
      lineHeight: '22px',
      marginBottom: 0,
      [breakpoints.down(breakpoints.values.sm)]: {
        fontSize: typography.fontSM,
        lineHeight: '14px',
      },
    },
    secondaryNameSummarySection: {
      display: 'inline',
      fontSize: typography.fontMD,
      lineHeight: '24px',
    },
    divider: {
      borderColor: palette.text.primary,
      borderWidth: '1px',
      display: 'inline-block',
      margin: '0 7px',
      height: '11px',
      [breakpoints.down(breakpoints.values.sm)]: {
        margin: '0 5px',
        height: '8px',
        lineHeight: '10px',
      },
    },
    modelNameText: {},
    variantNameText: {},
    trimLevelsPageTitle: {},
  }),
  { name: 'Customise_TrimLevelName' },
);

export default trimLevelNameStyles;
